// extracted by mini-css-extract-plugin
module.exports = {"content":"newsletter-pop-up-content_content__hiKZj","title":"newsletter-pop-up-content_title__GUbQA"};